module.exports = __webpack_public_path__ + "img/logo_w.82bd2375.svg";